import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Token routing — admin endpoints get the admin token; everything else gets the
// customer token. Without this, having both tokens in localStorage caused the
// admin's /auth/me to be called with the customer token and 403 → wiping admin.
const isAdminUrl = (url = "") =>
  url.startsWith("/admin") ||
  url.startsWith("/shipping/create") ||
  url.startsWith("/shipping/cancel") ||
  url.startsWith("/auth/admin/") ||
  url === "/auth/login" ||
  url === "/auth/me";

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const adminToken = localStorage.getItem("cynos_admin_token");
  const customerToken = localStorage.getItem("cynos_customer_token");
  const token = isAdminUrl(url) ? adminToken : customerToken;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
